/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import actionIcon from '../../../../../assets/images/Fireboard/action.png';
import noteIcon from '../../../../../assets/images/Fireboard/note-white.png';
import classes from './SlotHeader.module.css';

const SlotHeader = ({ slot, showPopup, occupied, onShowCheckDetails }) => {
  return (
    <div className={classes.headerContainer}>
      <div className={classes.headerSecondPart}>
        <span className={classes.slotName}>{slot?.name}</span>
      </div>
      {occupied && (
        <div className={classes.headerThirdPart}>
          <img
            src={noteIcon}
            alt='note'
            className={classes.noteImg}
            onClick={() => onShowCheckDetails(slot?.checkData || {})}
          />
          <img
            src={actionIcon}
            onClick={() => showPopup('check-actions', slot)}
            className={classes.menuIcon}
            alt='menu'
          />
        </div>
      )}
    </div>
  );
};

export default SlotHeader;

SlotHeader.propTypes = {
  slot: PropTypes.object,
  showPopup: PropTypes.func,
  occupied: PropTypes.bool,
  onShowCheckDetails: PropTypes.func,
};

SlotHeader.defaultProps = {
  slot: {},
  showPopup: () => { },
  occupied: false,
  onShowCheckDetails: () => { },
};
